// 字段数据状态管理
export default {
  namespaced: true,
  
  state: {
    searchKeyword: '',
    fieldCategories: {
      tableFields: {
        title: '表格区字段',
        expanded: true,
        fields: [
          { id: 'product_code', name: '商品编码', selected: false, editable: true, displayName: '商品编码', category: 'table' },
          { id: 'product_name', name: '商品名称', selected: false, editable: true, displayName: '商品名称', category: 'table' },
          { id: 'primary_category', name: '一级分类', selected: false, editable: true, displayName: '一级分类', category: 'table' },
          { id: 'secondary_category', name: '二级分类', selected: false, editable: true, displayName: '二级分类', category: 'table' },
          { id: 'product_brand', name: '商品品牌', selected: false, editable: true, displayName: '商品品牌', category: 'table' },
          { id: 'barcode', name: '条形码', selected: false, editable: true, displayName: '条形码', category: 'table' },
          { id: 'barcode_code', name: '条形码 (编码)', selected: false, editable: true, displayName: '条形码 (编码)', category: 'table' },
          { id: 'production_date', name: '生产日期', selected: false, editable: true, displayName: '生产日期', category: 'table' },
          { id: 'shelf_life', name: '保质期', selected: false, editable: true, displayName: '保质期', category: 'table' }
        ]
      },
      headerFooterFields: {
        title: '表头/表尾区字段',
        expanded: false,
        fields: [
          { 
            id: 'main_info', 
            name: '主体信息', 
            selected: false, 
            editable: true, 
            displayName: '主体信息',
            expanded: false,
            category: 'header',
            subFields: [
              { id: 'page_number', name: '页码', selected: false, editable: true, displayName: '页码', category: 'header' },
              { id: 'order_number', name: '订单号', selected: false, editable: true, displayName: '订单号', category: 'header' },
              { id: 'order_type', name: '订单类型', selected: false, editable: true, displayName: '订单类型', category: 'header' },
              { id: 'order_time', name: '下单时间', selected: false, editable: true, displayName: '下单时间', category: 'header' },
              { id: 'delivery_time', name: '配送时间', selected: false, editable: true, displayName: '配送时间', category: 'header' },
              { id: 'payment_method', name: '支付方式', selected: false, editable: true, displayName: '支付方式', category: 'header' },
              { id: 'order_remarks', name: '订单备注', selected: false, editable: true, displayName: '订单备注', category: 'header' }
            ]
          },
          { 
            id: 'consignee_info', 
            name: '收货信息', 
            selected: false, 
            editable: true, 
            displayName: '收货信息',
            expanded: false,
            category: 'header',
            subFields: [
              { id: 'customer_name', name: '客户名称', selected: false, editable: true, displayName: '客户名称', category: 'header' },
              { id: 'contact_person', name: '联系人', selected: false, editable: true, displayName: '联系人', category: 'header' },
              { id: 'receiving_mobile', name: '收货手机', selected: false, editable: true, displayName: '收货手机', category: 'header' },
              { id: 'customer_code', name: '客户编码', selected: false, editable: true, displayName: '客户编码', category: 'header' },
              { id: 'shipping_address', name: '收货地址', selected: false, editable: true, displayName: '收货地址', category: 'header' }
            ]
          }
        ]
      },
      columnFields: {
        title: '分栏区字段',
        expanded: false,
        fields: [
          { id: 'total_order_qty', name: '下单数量合计', selected: false, editable: true, displayName: '下单数量合计', category: 'column' },
          { id: 'total_shipment_qty', name: '发货数量合计', selected: false, editable: true, displayName: '发货数量合计', category: 'column' },
          { id: 'order_weight', name: '订单重量(kg)', selected: false, editable: true, displayName: '订单重量(kg)', category: 'column' },
          { id: 'actual_total_price', name: '实际总价', selected: false, editable: true, displayName: '实际总价', category: 'column' },
          { id: 'order_amount', name: '下单金额', selected: false, editable: true, displayName: '下单金额', category: 'column' },
          { id: 'shipment_amount', name: '发货金额', selected: false, editable: true, displayName: '发货金额', category: 'column' }
        ]
      },
      otherFields: {
        title: '其他信息',
        expanded: false,
        fields: [
          { id: 'order_product_qr_code', name: '订单商品二维码', selected: false, editable: true, displayName: '订单商品二维码', category: 'other' },
          { id: 'special_remarks', name: '特殊备注', selected: false, editable: true, displayName: '特殊备注', category: 'other' }
        ]
      }
    }
  },
  
  mutations: {
    SET_SEARCH_KEYWORD(state, keyword) {
      state.searchKeyword = keyword
    },
    
    TOGGLE_CATEGORY(state, categoryName) {
      if (state.fieldCategories[categoryName]) {
        state.fieldCategories[categoryName].expanded = !state.fieldCategories[categoryName].expanded
      }
    },
    
    TOGGLE_SUB_FIELDS(state, { categoryName, fieldId }) {
      const category = state.fieldCategories[categoryName]
      if (category) {
        const field = category.fields.find(f => f.id === fieldId)
        if (field && field.subFields) {
          field.expanded = !field.expanded
        }
      }
    },
    
    TOGGLE_FIELD_SELECTION(state, { categoryName, fieldId, subFieldId = null }) {
      const category = state.fieldCategories[categoryName]
      if (!category) return
      
      if (subFieldId) {
        // 处理子字段
        const parentField = category.fields.find(f => f.id === fieldId)
        if (parentField && parentField.subFields) {
          const subField = parentField.subFields.find(sf => sf.id === subFieldId)
          if (subField) {
            subField.selected = !subField.selected
            if (subField.selected && !subField.displayName) {
              subField.displayName = subField.name
            }
          }
        }
      } else {
        // 处理主字段
        const field = category.fields.find(f => f.id === fieldId)
        if (field) {
          field.selected = !field.selected
          if (field.selected && !field.displayName) {
            field.displayName = field.name
          }
        }
      }
    },
    
    UPDATE_FIELD_DISPLAY_NAME(state, { categoryName, fieldId, subFieldId = null, displayName }) {
      const category = state.fieldCategories[categoryName]
      if (!category) return
      
      if (subFieldId) {
        const parentField = category.fields.find(f => f.id === fieldId)
        if (parentField && parentField.subFields) {
          const subField = parentField.subFields.find(sf => sf.id === subFieldId)
          if (subField) {
            subField.displayName = displayName
          }
        }
      } else {
        const field = category.fields.find(f => f.id === fieldId)
        if (field) {
          field.displayName = displayName
        }
      }
    }
  },
  
  actions: {
    setSearchKeyword({ commit }, keyword) {
      commit('SET_SEARCH_KEYWORD', keyword)
    },
    
    toggleCategory({ commit }, categoryName) {
      commit('TOGGLE_CATEGORY', categoryName)
    },
    
    toggleSubFields({ commit }, payload) {
      commit('TOGGLE_SUB_FIELDS', payload)
    },
    
    toggleFieldSelection({ commit }, payload) {
      commit('TOGGLE_FIELD_SELECTION', payload)
    },
    
    updateFieldDisplayName({ commit }, payload) {
      commit('UPDATE_FIELD_DISPLAY_NAME', payload)
    }
  },
  
  getters: {
    filteredFields: (state) => (categoryName) => {
      const category = state.fieldCategories[categoryName]
      if (!category || !state.searchKeyword) return category.fields
      
      return category.fields.filter(field => {
        const matchesName = field.name.toLowerCase().includes(state.searchKeyword.toLowerCase())
        const matchesSubFields = field.subFields ? 
          field.subFields.some(sf => sf.name.toLowerCase().includes(state.searchKeyword.toLowerCase())) : 
          false
        return matchesName || matchesSubFields
      })
    },
    
    selectedFields: (state) => {
      const selected = []
      Object.values(state.fieldCategories).forEach(category => {
        category.fields.forEach(field => {
          if (field.selected) {
            selected.push(field)
          }
          if (field.subFields) {
            field.subFields.forEach(subField => {
              if (subField.selected) {
                selected.push(subField)
              }
            })
          }
        })
      })
      return selected
    },
    
    selectedTableFields: (state, getters) => {
      return getters.selectedFields.filter(field => field.category === 'table')
    }
  }
}
